import { Component, OnInit, HostListener } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import {
    Location,
    LocationStrategy,
    PathLocationStrategy,
} from "@angular/common";
import { AnalyticsService } from "src/app/shared/services/analytics.service";
import { LanguageService } from "src/app/shared/services/language.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-navbar",
    templateUrl: "./navbar.component.html",
    styleUrls: ["./navbar.component.scss"],
    providers: [
        Location,
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy,
        },
    ],
})
export class NavbarComponent implements OnInit {
    location: any;
    navbarClass: any;
    isSticky: boolean = false;

    get isFrench(): boolean {
        return this.translate.currentLang === "fr";
    }

    @HostListener("window:scroll", ["$event"])
    checkScroll(_event?: Event) {
        const scrollPosition =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;
        if (scrollPosition >= 120) {
            this.isSticky = true;
        } else {
            this.isSticky = false;
        }
    }

    constructor(
        private router: Router,
        public analyticsService: AnalyticsService,
        private language: LanguageService,
        private translate: TranslateService,
    ) {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.location = this.router.url;
                if (
                    this.location == "/" ||
                    this.location == "/home-2" ||
                    this.location == "/home-3" ||
                    this.location == "/home-5" ||
                    this.location == "/home-6" ||
                    this.location == "/home-7" ||
                    this.location == "/without-animation-home-1" ||
                    this.location == "/without-animation-home-2" ||
                    this.location == "/without-animation-home-3" ||
                    this.location == "/without-animation-home-5" ||
                    this.location == "/without-animation-home-6" ||
                    this.location == "/without-animation-home-7"
                ) {
                    this.navbarClass = "navbar-area";
                } else if (
                    this.location == "/home-4" ||
                    this.location == "/without-animation-home-4"
                ) {
                    this.navbarClass = "navbar-area bg-white";
                } else {
                    this.navbarClass = "navbar-area navbar-style-two";
                }
            }
        });
    }

    ngOnInit() {}

    setLang(lang: "en" | "fr"): void {
        this.language.setLang(lang);
    }
}
